export default [
    {
        name: "머리가 앞으로 쏠림",
        key: "forwardhead",
        definition: {
            name: "정의",
            list: ["머리가 앞으로 쏠림은 인체가 자연스러운 서있는 자세나 앉은 자세일 때 머리가 몸통에 비해 비정상적으로 앞으로 쏠린 위치에 있다는 것을 의미합니다. 오래 앉아있는 학생들과 사무실 근무자들에게 흔히 나타납니다."]
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 장기간 몸을 숙여 일하다. 업무 중 오랜 시간 컴퓨터 앞에 앉아 있으면 머리가 습관적으로 앞으로 나온다.",
                "2. 습관적으로 머리를 숙여 휴대폰을 보다. 머리를 숙여 휴대폰을 보는, 이른바 ‘머리 숙인족’ 또한 머리가 앞으로 쏠리는 주요 유발 원인이다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 어지럼증과 두통: 머리가 앞으로 쏠리면 머리의 혈류에 영향을 줄 수 있습니다. 혈류가 원활하지 않으면 머리에 산소 부족이 발생하여 어지럼증과 두통을 유발합니다.",
                "2. 경추병: 머리의 비정상적인 위치로 인해 목의 연부조직과 뼈에 이상이 발생하여 경추병에 걸릴 위험이 증가합니다.",
                "3. 심혈관 질환 및 뇌혈관 질환: 머리의 비정상적인 위치는 머리의 혈류에 영향을 줄 수 있으며 심혈관 및 뇌혈관 건강에 해를 끼칠 수 있습니다.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "머리 측면 기울기",
        definition: {
            name: "정의",
            list: ["머리 측면 기울기는 인체가 자연스러운 서있는 자세나 앉은 자세일 때 머리가 과도하게 한쪽으로 기울어진 비정상적인 자세를 말합니다. 주요 유발 요인은 양쪽 어깨와 목의 근육 힘의 불균형이며, 대부분 습관적인 잘못된 자세로 인해 발생합니다."]
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 한쪽 어깨와 목의 근육을 습관적으로 사용하기: 앉거나 누울 때 목은 종종 한쪽으로만 기울어져 양쪽 어깨와 목의 근육 힘의 불균형을 초래한다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 근육과 인대의 만성 피로: 오랜 기간 머리가 측면으로 기울어지면 목 뒤쪽의 인대 및 근육 인대의 만성 피로가 쉽게 발생합니다.",
                "2. 경추병: 머리의 비정상적인 위치로 인해 목의 연부조직과 뼈에 이상이 발생하여 경추병에 걸릴 위험이 증가합니다.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "어깨 높낮이 불균형",
        definition: {
            name: "정의",
            list: ["어깨 높낮이 불균형은 인체가 자연스럽게 이완된 상태에서 양쪽 어깨의 수직 높이가 다른 상황을 말합니다. 보통 어깨 높낮이 불균형은 척추 자세의 이상을 동반합니다."]
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 한쪽에 과도한 힘 가하기: 예를 들어, 장기간 한쪽에 가방을 메거나 무거운 물건을 들기.",
                "2. 장기간 잘못된 자세: 오랫동안 다리를 꼬고 앉거나, 책상에 기대어 일하는 등 나쁜 습관으로 인해 발생합니다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 허리통증: (어깨 높낮이 불균형)은 골반의 변위를 일으킬 수 있으며, 허리 양쪽의 근력 불균형을 초래하여 허리통증을 유발합니다.",
                "2. 골극: 어깨 높낮이 불균형은 경추에 비정상적인 힘이 가해지고, 마지막에는 경추 부위가 퇴행되어 골극이 쉽게 형성됩니다.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "둥근 어깨",
        definition: {
            name: "정의",
            list: ["둥근 어깨는 옆에서 인체를 관찰했을 때 어깨가 앞쪽과 안쪽으로 구부러진 상태를 말합니다. 대부분 등 굽음과 함께 나타납니다. 학생이나 사무실에서 근무하는 사람들에게 흔합니다."],
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 습관적인 자세 불량: 예를 들어, 앞으로 구부린 자세와 등 굽음, 불규칙한 옆으로 누워 자기 등.",
                "2. 가슴과 등의 근력 불균형: 가슴 근육은 등 근육에 비해 상대적으로 약하다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 심장 부담 증가: 과도한 둥근 어깨는 횡격막을 긴장시키고 대동맥과 대정맥을 압박하여 심장의 작업 부담을 증가시킵니다.",
                "2. 신경이 눌리다: 어깨와 목 주변의 근육이 긴장되면, 심각한 경우 경추 신경이 눌려 두통과 팔의 저림을 유발할 수 있다.",
            ],
        }
    },
    {
        name: "척추측만증",
        key: "scoliosis",
        definition: {
            name: "정의",
            list: ["척추 위치에 이상이 발생합니다. 영상 검사를 통해 척추 측만증 등 척추의 비정상 상태를 발견할 수 있습니다. 이상은 선천적과 후천적으로 나뉩니다. 후천적 이상은 습관적인 자세 오류와 관련이 있습니다."],
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 한쪽에 과도한 힘 가하기: 예를 들어, 오랫동안 한쪽에 가방을 메거나 무거운 물건을 들기.",
                "2. 장기간 잘못된 자세: 오랫동안 다리를 꼬고 앉거나, 책상에 기대어 일하는 등 나쁜 습관으로 인해 발생합니다.",
                "3. 선천적인 원인: 선천적으로 인한 척추측만증.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 요추간판탈출증.",
                "2. 허리통증: 골반의 변위를 일으킬 수 있으며, 허리 양쪽의 근력 불균형을 초래하여 허리통증을 유발할 수 있습니다.",
                "3. 길이가 다른 다리.",
            ],
        }
    },
    {
        name: "골반 측면 기울기",
        key: "unevenhip",
        definition: {
            name: "정의",
            list: ["골반 측면 기울기는 양쪽 엉덩이의 높이가 상당히 차이 나고, 골반이 기울어진 상태를 말합니다. 대부분 척추 위치 이상과 높낮이가 다른 어깨와 함께 나타납니다."],
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 장기간 잘못된 자세: 오랫동안 다리를 꼬고 앉거나, 책상에 기대어 일하는 등 나쁜 습관으로 인해 발생합니다.",
                "2. 선천적인 길이가 다른 다리: 선천적인 길이가 다른 다리로 인한 골반 측면 기울기.",
                "3. 양쪽 하지 자세 불균형: 예를 들어, 한쪽 발은 평발이고 다른 쪽은 아니거나 정도가 다르다. 양쪽 모두 무릎 과신전 현상이 있지만 정도가 다르다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 요추간판탈출증.",
                "2. 만성 통증: 골반 측면 기울기는 허리와 다리, 목과 어깨 통증을 유발할 수 있습니다.",
                "3. 길이가 다른 다리.",
            ],
        }
    },
    {
        name: "O 자 모양의 다리",
        key: "oleg",
        definition: {
            name: "정의",
            list: ["인체가 정상적인 자세로 서 있고 두 발을 모았을 때, 안쪽 발목은 밀착될 수 있지만 무릎 안쪽은 밀착되지 못하고 심지어 큰 틈이 있을 수 있습니다. 다리 사이에 ‘O’ 모양이 나타납니다. 이러한 다리 모양은 일상적인 자세 습관과 관련이 있습니다. 어린이에게 ‘O’자 모양의 다리가 나타나는 것은 구루병과 관련이 있을 수도 있습니다."],
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 습관적인 나쁜 자세 예: 골반 후倾,족내반 경향.",
                "2. 근육 힘의 불균형 예: 엉덩이 외회전근이 너무 긴장된 상태.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 내측 반월판 손상: O 자 모양의 다리로 인해 하지의 힘선이 바뀌고, 무릎 관절의 내측 틈이 정상 부하보다 큰 압력을 받습니다. 무릎 관절의 내측 반월판 손상을 일으킬 수 있습니다.",
                "2. 관절염: 심각한 경우(O 자 모양의 다리)는 결국 무릎 관절 골관절염, 관절 외측 간격의 관절 퇴행으로 발전할 수 있습니다. 심각한 경우 인공 관절 치환 수술이 필요할 수 있습니다.",
            ],
        }
    },
    {
        name: "X 자 모양의 다리",
        key: "xleg",
        definition: {
            name: "정의",
            list: "인체가 정상적인 자세로 서 있고 다리를 모았을 때, 안쪽 무릎은 밀착할 수 있지만 양쪽 발목 안쪽은 밀착할 수 없고 심지어 큰 틈이 있을 수 있습니다. 다리 사이에는 'X' 모양이 나타납니다. 이러한 다리 형태는 일상적인 자세 습관과 근력 불균형과 관련이 있습니다.",
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 습관적인 나쁜 자세 예: 골반 전倾, 족저외반 경향.",
                "2. 근력 불균형 예: 고관절 내회전근이 너무 긴장.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 외측 반월판 손상: X 자 모양의 다리로 인해 하지의 힘선이 바뀌고, 무릎 관절의 외측 틈이 정상 부하보다 큰 압력을 받습니다. 무릎 관절의 외측 반월판 손상을 일으킬 수 있습니다.",
                "2. 관절염: 심각한 경우(X 자 모양의 다리)는 결국 무릎 관절 골관절염, 관절 외측 간격의 관절 퇴행으로 발전할 수 있습니다. 심각한 경우 인공 관절 치환 수술이 필요할 수 있습니다.",
            ],
        }
    },
    {
        name: "무릎 과신전",
        key: "kneehyperextension",
        definition: {
            name: "정의",
            list: ["무릎 과신전, 또 다른 이름은 '무릎 역궁(膝反弓)'. 인체 측면에서 보면 다리가 뒤쪽으로 굽고, 무릎이 안쪽으로 들어가고, 종아리는 대퇴부에 비해 과도하게 앞으로 뻗어 있습니다. 이러한 자세는 발레리나와 대퇴부 근력이 약한 사람들에게 흔히 나타납니다."],
        },
        triggerreason: {
            name: "원인",
            list: [
                "1. 잘못된 발력 자세: 서 있을 때 주요 무게가 앞발에 실린다.",
                "2. 족저근막 긴장: 장기간 하이힐을 신는 것으로 인해 발생할 수 있습니다.",
                "3. 무릎 주변의 근육 힘이 약하고, 대퇴부 전후측 근력이 부족합니다.",
            ]
        },
        danger: {
            name: "위험",
            list: [
                "1. 무릎 관절 기형: 장기간 무릎 과신전은 관절 퇴행의 발생률을 현저히 높일 수 있으며, 무릎의 과도한 마모를 유발하여 관절 기형을 초래할 수 있습니다.",
                "2. 전신 균형이 손상됨: 고관절, 무릎 관절, 발목 관절 세 관절 사이에는 큰 위치적, 기능적 연관이 있습니다. 무릎 관절 위치의 변화는 그 아래의 발목 관절 위치와 위의 고관절, 골반 위치에 영향을 주며, 점차 전신의 균형 상태를 손상시킵니다. 장기적으로는 다양한 종류의 통증을 유발할 수 있습니다.",
            ],
        }
    },
]